import React, { useEffect, useState, useContext, Fragment } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames/bind';

import { CountryContext } from 'context/CountryContext';
import { SearchContext } from 'context/SearchContext';
import { ProductTabsContext } from 'context/ProductTabsContext';

import PartItem from '../PartItem';
import Loader from 'components/Loader';

import { getProductPartList } from 'utils/getProductPartsList';
import { getDirectArticlesInfo } from 'utils/getArtclesInfo';

import styles from './TabPartList.module.scss';

const cx = classNames.bind(styles);

const TabPartList = ({ articleId }) => {
  const { partsListTab, setPartsListTab } = useContext(ProductTabsContext);
  const { currentCountry } = useContext(CountryContext);
  const { vehicleType } = useContext(SearchContext);
  const [isLoading, setIsLoading] = useState(!partsListTab);

  const getProductPartsSuccess = ({ data: response }) => {
    const partlistObj = response.data.array[0] ? response.data.array[0] : {};
    const articlesArray = partlistObj.partlistInfo
      ? partlistObj.partlistInfo.array.map(
          (item) => item.partlistDetails.partArticleId
        )
      : [];

    getDirectArticlesInfo({
      articleId: {
        array: articlesArray,
      },
      articleCountry: currentCountry,
    }).then(({ data: response }) => {
      setIsLoading(false);
      setPartsListTab((response.data && response.data.array) || null);
    });
  };

  useEffect(() => {
    if (!partsListTab) {
      getProductPartList(articleId, currentCountry, vehicleType).then(
        getProductPartsSuccess
      );
    }
  }, [articleId]);

  if (isLoading) {
    return (
      <div className={cx('root')}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={cx('root')}>
      {partsListTab && (
        <Fragment>
          {partsListTab.map((item, index) => (
            <PartItem data={item} key={index} className={cx('part-item')} />
          ))}
        </Fragment>
      )}
    </div>
  );
};

TabPartList.propsType = {
  articleId: string.isRequired,
};

export default TabPartList;



// WEBPACK FOOTER //
// ./src/pages/Product/components/TabPartList/TabPartList.js